import styled from 'styled-components'

export const DangerText = styled.span`
  color: #FC4949;
`